import { defineComponent, ref, useListeners, computed, inject } from 'vue';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';
import { useStoreModule } from '../../composables/store-module/index.js';
import { useTableRow } from '../../composables/table-row/index.js';
import { usePagination } from '../../composables/pagination/index.js';
import UiPagination from '../ui-pagination/UiPagination.vue.js';
import UiName from '../ui-name/UiName.vue.js';
import HoistComponent from '../hoist-component/HoistComponent.vue.js';
import UiDropdownMenu from '../ui-dropdown-menu/UiDropdownMenu.vue.js';
import PortfolioListAction from './components/PortfolioListAction.vue.js';
import CloseButton from './components/CloseButton.vue.js';
import { portfolioCreateFactory } from '../portfolio-create/setup/index.js';
import { portfolioEditFactory } from '../portfolio-edit/setup/index.js';
import { portfolioDeleteFactory } from '../portfolio-delete/setup/index.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PortfolioList",
  props: {
    locale: { type: null, required: true },
    itemsPerPage: { type: Number, required: false, default: 10 }
  },
  emits: ["store-error", "data-load", "table-row-key-click", "table-row-click", "on-portfolio-create"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const errorBag = ref([]);
    const headers = [
      {
        key: "name",
        label: "portfolioList.label.name"
      },
      {
        key: "currency",
        label: "portfolioList.label.currency"
      },
      {
        key: "numberOfPositions",
        label: "portfolioList.label.numberOfPositions"
      },
      {
        key: "numberOfTransactions",
        label: "portfolioList.label.numberOfTransactions"
      },
      {
        key: "actions",
        label: "portfolioList.label.actions"
      }
    ];
    const listeners = useListeners();
    const componentInputs = computed(() => ({
      itemsPerPage: pagination.itemsPerPage.value,
      pageOffset: pagination.activePageOffset.value,
      language: props.locale
    }));
    const showNoPortfoliosAlert = computed(() => {
      return totalItems.value === 0 && !isLoadingStoreData.value && !hasStoreErrors.value;
    });
    const injectedStoreModule = inject("storeModule");
    const translator = inject("translator");
    const numberFormatter = inject("numberFormatter");
    const dateFormatter = inject("dateFormatter");
    const PortfolioCreate = portfolioCreateFactory({
      translator,
      numberFormatter,
      dateFormatter,
      storeModule: (injectedStoreModule == null ? void 0 : injectedStoreModule.getDependencies) ? injectedStoreModule.getDependencies().portfolioCreate : void 0
    });
    const PortfolioEdit = portfolioEditFactory({
      translator,
      numberFormatter,
      dateFormatter,
      storeModule: (injectedStoreModule == null ? void 0 : injectedStoreModule.getDependencies) ? injectedStoreModule.getDependencies().portfolioEdit : void 0
    });
    const PortfolioDelete = portfolioDeleteFactory({
      translator,
      numberFormatter,
      dateFormatter,
      storeModule: (injectedStoreModule == null ? void 0 : injectedStoreModule.getDependencies) ? injectedStoreModule.getDependencies().portfolioDelete : void 0
    });
    const localizationSupport = useLocalizationSupport(props, { translator, numberFormatter, dateFormatter });
    const { translate, numberFormat, textFormat } = localizationSupport;
    const tableRow = useTableRow(listeners, emits);
    const { tableRowAttributes, hasTableRowClickListener, hasTableRowKeyClickListener, tableRowEvents, onTableRowKeyClick } = tableRow;
    const totalItems = computed(() => {
      var _a, _b;
      return (_b = (_a = storeMeta.value) == null ? void 0 : _a.pagination.total) != null ? _b : 0;
    });
    const pagination = usePagination(props, totalItems);
    const { totalPages, activePageOffset, onClickPagination } = pagination;
    const storeModule = useStoreModule({ storeModule: injectedStoreModule }, componentInputs, emits);
    const { storeData, storeMeta, isLoadingStoreData, hasStoreErrors } = storeModule;
    const onError = (errors, callBack) => {
      errorBag.value = errors.map((error) => error.message);
      setTimeout(() => {
        errorBag.value = [];
      }, 5e3);
      callBack();
    };
    const onPortfolioCreate = (payload, callBack) => {
      if (payload) {
        emits("on-portfolio-create", payload);
      }
      callBack();
    };
    return { __sfc: true, errorBag, headers, props, emits, listeners, componentInputs, showNoPortfoliosAlert, injectedStoreModule, translator, numberFormatter, dateFormatter, PortfolioCreate, PortfolioEdit, PortfolioDelete, localizationSupport, translate, numberFormat, textFormat, tableRow, tableRowAttributes, hasTableRowClickListener, hasTableRowKeyClickListener, tableRowEvents, onTableRowKeyClick, totalItems, pagination, totalPages, activePageOffset, onClickPagination, storeModule, storeData, storeMeta, isLoadingStoreData, hasStoreErrors, onError, onPortfolioCreate, UiPagination, UiName, HoistComponent, UiDropdownMenu, PortfolioListAction, CloseButton };
  }
});

export { _sfc_main as default };
